import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    if (pw.length < 8) { toast.error("Use at least 8 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset · signed in");
      await checkAuth();
      navigate("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  if (!token) return <div className="p-10 text-center text-muted-foreground" data-testid="reset-missing-token">Reset token missing.</div>;

  return (
    <div data-testid="page-reset" className="mx-auto max-w-md px-4 py-16">
      <div className="border border-border p-8 space-y-4">
        <h1 className="font-display text-3xl">Choose a new password</h1>
        <div>
          <Label className="font-overline">New Password</Label>
          <Input type="password" className="rounded-none mt-2" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw" />
        </div>
        <div>
          <Label className="font-overline">Confirm Password</Label>
          <Input type="password" className="rounded-none mt-2" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2" />
        </div>
        <Button onClick={submit} disabled={busy || !pw || !pw2} className="w-full rounded-none uppercase tracking-wider h-11" data-testid="reset-submit">
          {busy ? "…" : "Reset Password"}
        </Button>
      </div>
    </div>
  );
}
